import { useRef } from 'react';

const safeDocument = typeof document !== 'undefined' ? document : {};

/**
 * Usage:
 *
 * const [blockScroll, allowScroll] = useScrollBlock();
 */
const useScrollBlock = () => {
  const scrollBlocked = useRef();
  const html = safeDocument.documentElement;
  const { body } = safeDocument;

  const blockScroll = () => {
    if (!body || !body.style || scrollBlocked.current) {
      return;
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = html.clientWidth;
    const width = Math.abs(window.innerWidth - documentWidth);

    const calculatedValue = window.getComputedStyle(body)['paddingRight'];

    body.style['overflow'] = 'hidden';

    // trick: We adjust negative marginRight and positive paddingRight to sticky-top elements to keep showing fullwidth
    body.style['marginRight'] = `${
      Number.parseFloat(calculatedValue) - width
    }px`;

    body.style['paddingRight'] = `${
      Number.parseFloat(calculatedValue) + width
    }px`;

    scrollBlocked.current = true;
  };

  const allowScroll = () => {
    if (!body || !body.style || !scrollBlocked.current) {
      return;
    }

    body.style['overflow'] = '';
    body.style['marginRight'] = '';
    body.style['paddingRight'] = '';

    scrollBlocked.current = false;
  };

  return [blockScroll, allowScroll];
};

export default useScrollBlock;
